import Network from "../networkHandler/Network";

/**
 * Check whether a localization pack already exists on the platform for the
 * given gameId/language. Used to skip the "do you want to translate?" popup
 * when no translation work is needed.
 *
 * Mirrors the GET-then-abort approach used by `hasNewStoryFormat` because
 * the platform's static file route only handles GET (404 on HEAD).
 *
 * Defensive false on network failure: if we can't determine pack state,
 * fall through to the popup and let the user / server decide.
 */
export async function hasLanguagePack(
  gameId: number,
  language: string,
): Promise<boolean> {
  const platformUrl = Network.withServerUploadGame().getServerUrl();
  if (!platformUrl) return false;

  const controller = new AbortController();
  try {
    const res = await fetch(`${platformUrl}/game/${gameId}/${language}.json`, {
      method: "GET",
      signal: controller.signal,
    });
    controller.abort();
    return res.ok;
  } catch {
    return false;
  }
}
